import { saveImageOrVideoDataEndPoint } from 'components/b2b/Header/camera/cameraAdreses';

export const saveMedia = async (clientCode: string, fileName: string, data: Blob) => {
  try {
    const formData = new FormData();

    formData.append('fname', fileName);
    formData.append('data', data);
    formData.append('folder', clientCode);

    const res = await fetch(saveImageOrVideoDataEndPoint, {
      method: 'POST',
      body: formData,
    });

    return res;
  } catch (error) {
    console.log('Error saving media', error);
  }
};
